import type { ExibirTaskResponse } from "../model";

interface TarefaPDFParams {
	tarefa: ExibirTaskResponse;
	monitorId: string | number;
	monitorNome?: string;
	monitorDescricao?: string;
	grupoNome?: string;
}

interface PDFResult {
	success: boolean;
	error?: string;
}

export async function loadImageAsBase64(url: string): Promise<string> {
	const response = await fetch(url);
	const blob = await response.blob();
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onloadend = () => resolve(reader.result as string);
		reader.onerror = reject;
		reader.readAsDataURL(blob);
	});
}

export async function gerarPDFTarefa(params: TarefaPDFParams): Promise<PDFResult> {
	const { tarefa, monitorId, monitorNome, monitorDescricao, grupoNome } = params;

	let logoBase64 = "";
	try {
		logoBase64 = await loadImageAsBase64("/logo.jpg");
	} catch (error) {
		console.error("Erro ao carregar logo:", error);
	}

	const pdfRequest = {
		name: `tarefa_${tarefa.id}`,
		elements: [
			{ type: "image", src: logoBase64, x: 30, y: 25, width: 72, height: 20, align: "left" },
			{ type: "text", text: "Relatório de Tarefa", size: 18, style: "bold", align: "right" },
			{ type: "text", x: 30, y: 52, text: String(tarefa.id), size: 10, align: "right" },
			{ type: "line" },
			{ type: "text", text: "Informações:", size: 12, style: "bold" },
			{
				type: "table",
				columns: ["Campo", "Valor"],
				rows: [
					["Monitor", monitorNome || "N/A"],
					["Descrição", monitorDescricao || "N/A"],
					["Grupo", grupoNome || "N/A"],
					["Tarefa", `${window.location.origin}/monitorFormulario/${monitorId}/${tarefa.id}`],
					["URL", tarefa.url || "N/A"],
					["Método", tarefa.metodo || "N/A"],
					["Timeout", String(tarefa.timeout || "N/A")],
					["Condições", tarefa.condicoes || "N/A"],
					["Latência", tarefa.latencia || "N/A"],
					["Status Response", String(tarefa.statusResponse || "N/A")],
					["Sucesso", tarefa.sucesso ? "Sim" : "Não"],
					["Data Início", tarefa.dataInicio || "N/A"],
					["Data Fim", tarefa.dataFim || "N/A"],
				],
				theme: "striped",
				headStyles: { fillColor: "#000", textColor: "#fff" },
			},
			{ type: "text", text: "Request:", size: 12, style: "bold" },
			{
				type: "table",
				columns: ["Header", "Valor"],
				rows: tarefa.headersRequest && tarefa.headersRequest.length > 0 ? tarefa.headersRequest.map((h) => [h[0] || "", h[1] || ""]) : [["N/A", "N/A"]],
				theme: "striped",
				headStyles: { fillColor: "#000", textColor: "#fff" },
			},
			{
				type: "table",
				columns: ["Payload"],
				rows: [[tarefa.payloadRequest || "N/A"]],
				theme: "striped",
				headStyles: { fillColor: "#000", textColor: "#fff" },
			},
			{ type: "text", text: "Response:", size: 12, style: "bold" },
			{
				type: "table",
				columns: ["Header", "Valor"],
				rows: tarefa.headersResponse && tarefa.headersResponse.length > 0 ? tarefa.headersResponse.map((h) => [h[0] || "", h[1] || ""]) : [["N/A", "N/A"]],
				theme: "striped",
				headStyles: { fillColor: "#000", textColor: "#fff" },
			},
			{
				type: "table",
				columns: ["Payload"],
				rows: [[tarefa.payloadResponse || "N/A"]],
				theme: "striped",
				headStyles: { fillColor: "#000", textColor: "#fff" },
			},
		],
	};

	try {
		const response = await fetch(`${process.env.REACT_APP_A4B_PDF_URL}pdf`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"x-api-secret": `${process.env.REACT_APP_A4B_PDF_SECRET}`,
			},
			body: JSON.stringify(pdfRequest),
		});

		if (!response.ok) {
			throw new Error("Erro ao gerar PDF");
		}

		const blob = await response.blob();
		const url = window.URL.createObjectURL(blob);
		const a = document.createElement("a");
		a.href = url;
		a.download = `tarefa_${tarefa.id}.pdf`;
		document.body.appendChild(a);
		a.click();
		window.URL.revokeObjectURL(url);
		document.body.removeChild(a);

		return { success: true };
	} catch (error) {
		return { success: false, error: error instanceof Error ? error.message : "Erro ao gerar PDF" };
	}
}
